<template>
    <div class="files_block resolution">
        <div class="card-body py-0 px-4 ">
            <div class="d-flex flex-column align-items-center">
                <!-- comment -->
                <div class="d-flex flex-row w-100 py-4 m-0 w-100"  v-for="chat in items">
                    <div class="d-inline-block align-middle status status-sm status-success mr-3" >
                        <span class="profile-image profile-image rounded-circle d-block mt-1"
                              v-bind:style="{
                                      'background-image': 'url(' + chat.portal_user.medium_img + ')',
                                      'background-size': 'cover'
                              }"
                        >
                        </span>
                    </div>
                    
                    <div class="mb-0 flex-1 text-dark">
                        <div class="d-flex">
                            <div class="text-dark fw-500">
                                {{ chat.portal_user.name}}
                            </div>
                            <span class="text-muted fs-xs opacity-70 ml-auto">
                                  {{fmtDate(chat.added)}}
                            </span>
                            
                            <span href="#" class="text-muted ml-4 cursor-pointer" title="delete"  @click="remove_item(chat.id)">
                                <i class="fal fa-trash-alt"></i>
                            </span>
                        </div>
                        <p class="mb-0">
                            {{chat.comment}}
                        </p>
                    </div>
                </div>
                <hr class="m-0 w-100">
                <!-- comment end -->
                
                <div class="py-3 w-100">
                    <BFormTextarea
                        style="min-height: 130px" v-model="text" :state="text.length >= 2"  placeholder="Додати коментар..."
                                     class="form-control "
                                     size="sm"
                    ></BFormTextarea>
                    
                    <div class="text-right">
                        <button type="button" class="btn btn-lg btn-primary waves-effect waves-themed mt-5 mb-5"
                                @click="add_item" :disabled="is_dis_save">
                            <span class="fal fa-download mr-1"></span>
                            Додати
                        </button>
                    </div>
                </div>
                <!-- add comment end -->
            </div>
        </div>
    </div>
</template>

<script>
import {
    BFormTextarea,
    BOverlay,
    BTable,
    BCard
} from 'bootstrap-vue-next';

export default {
    name: "cont_comments",
    
    components : {
        BFormTextarea
    },
    
    props : {
        contragent : {
            type : Object,
            required : true,
        }
    },
    
    data() {
        return {
            text: '',
            is_dis_save: false,
            is_load : false,
            fields: [
                {
                    key: 'fio',
                    label: 'ПIБ',
                },
                {
                    key: 'message',
                    label: 'Повідомлення',
                    class:'text-justify'
                },
                {
                    key: 'date_format',
                    class : 'date_d',
                    label: 'Дата',
                },
                {
                    key : 'link_rem',
                    label: '<i data-original-title="Видалити " class="fa fa-trash"></i>',
                },
            ],
            items: [],
        }
    },
    
    created() {
        this.getItems();
    },
    
    computed: {
    
    
    },
    
    methods: {
        show_loading(flag) {
        
        },
        
        async remove_item (chat_id) {
            this.is_load = true;
            await api.delete('/tenders/sales/tenders/contragents/' + parseInt(this.contragent.id) + '/messages/' + chat_id).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.is_load = false;
                    this.items = data.data;
                    this.contragent.messages = data.data;
                    this.is_load = false;
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async add_item () {
            
            if(this.text.length > 2) {
                this.is_load = true;
                await api.put('/tenders/sales/tenders/contragents/' + parseInt(this.contragent.id) + '/messages',{
                    'mes' : this.text
                }).then(({data}) => {
                    this.is_load = false;
                    this.text = '';
                    
                    if (data.status === "operation_success") {
                        this.items = data.data;
                        this.contragent.messages = data.data;
                        this.is_load = false;
                    }
                }).catch(err => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            }
        },
        
        
        async getItems() {
            this.contragent.messages = [];
            this.show_loading(true);
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.contragent.id) + '/messages').then(({data}) => {
                if (data.status === "operation_success") {
                    this.items = data.data;
                    this.contragent.messages = data.data;
                }
            }).catch(err => {
                this.show_loading(false);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
            
        },
        
    },
}
</script>

<style scoped>

.move_down {
    position: absolute;
    bottom: 0;
    left: 15px;
}

th i {
    color:white;
}

.fa-trash {
    cursor: pointer;
}
</style>
